import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { toastr } from 'react-redux-toastr';
import HudVoucherService from '../../services/hudVoucherService';
import { getHudVoucherTenantEventsQueryKey } from './hooks.hudVoucherQueryKeys';

const DEFAULT_QUERY_PARAMS = {
  page: 1,
  limit: 100,
  sort: 'effectiveDate',
  order: 'DESC',
};

const useHUDVoucherTenantEventsQuery = ({
  organizationId,
  propertyId,
  hudVoucherId,
  hudTenantEvents,
  queryParams,
  options: baseOptions,
}) => {
  const tenantEventsQueryKey = getHudVoucherTenantEventsQueryKey(
    organizationId,
    propertyId,
    hudVoucherId,
  );

  const tenantEventsQueryParams = useMemo(
    () => ({ ...DEFAULT_QUERY_PARAMS, ...(queryParams ?? {}) }),
    [queryParams],
  );

  const options = useMemo(() => {
    return {
      ...baseOptions,
      enabled: Boolean(
        hudTenantEvents && organizationId && propertyId && hudVoucherId,
      ),
      refetchOnWindowFocus: false,
      retry: false,
      onError: (e) => {
        const msg =
          e?.message ||
          e?.error ||
          'Failed to load HUD voucher tenant events. Please try again.';

        toastr.error('Error', msg);
      },
    };
  }, [baseOptions, hudTenantEvents, hudVoucherId, organizationId, propertyId]);

  return useQuery(
    tenantEventsQueryKey,
    async () => {
      const service = new HudVoucherService();
      return service.getHudVoucherTenantEvents(
        organizationId,
        propertyId,
        hudVoucherId,
        tenantEventsQueryParams,
      );
    },
    options,
  );
};

export default useHUDVoucherTenantEventsQuery;
